// extracted by mini-css-extract-plugin
export default {"customButton":"CreateButton_customButton__3SwXe"};